import React from 'react';
import i18n from '../../../../../i18n';
import { fmt } from '../../../data/metrics';
import type { DrillSellNoShow, DrillSellNoShowArm } from '../../../types';
import { DrillTile } from './DrillTile';

const T = 'performance:drillSell.noshow';

function ArmRow({
  label,
  arm,
  max,
}: {
  label: string;
  arm: DrillSellNoShowArm;
  max: number;
}) {
  return (
    <div className="dcrux-si-row">
      <span className="dcrux-si-name">{label}</span>
      <span className="dcrux-si-track">
        <span
          className="dcrux-si-fill"
          style={{ width: `${Math.max(2, (arm.ratePct / max) * 100)}%` }}
        />
      </span>
      <span className="dcrux-si-val">
        {arm.ratePct}%{' '}
        <span className="dsub-n">
          ·{' '}
          {i18n.t(`${T}.n`, {
            noshow: fmt.num(arm.noshow),
            count: fmt.num(arm.reservations),
          })}
        </span>
      </span>
    </div>
  );
}

export function DrillSellNoShowSection({
  data,
}: {
  metricKey: string;
  data: DrillSellNoShow;
}) {
  const max = Math.max(data.preorder.ratePct, data.without.ratePct, 0.0001);
  return (
    <DrillTile
      sectionId="sell-noshow"
      span={4}
      title={
        data.direction === 'less'
          ? i18n.t(`${T}.titleLess`)
          : i18n.t(`${T}.titleMore`)
      }
      meta={`n = ${fmt.num(data.preorder.reservations + data.without.reservations)}`}
    >
      <div className="dcrux-si-list">
        <ArmRow label={i18n.t(`${T}.withPre`)} arm={data.preorder} max={max} />
        <ArmRow label={i18n.t(`${T}.withoutPre`)} arm={data.without} max={max} />
      </div>
      <p className="ddrill-tile-note">{i18n.t(`${T}.basis`)}</p>
    </DrillTile>
  );
}
